import { Link as RemixLink, LinkProps } from "@remix-run/react";

import { disableTransitions } from "../NavLink";
import { cn } from "../utils";

import { buttonStyles, ButtonVariant } from "./Button";

type Props = {
  variant?: ButtonVariant | "plain";
} & LinkProps;

export function Link({ to, className, variant = "link", ...props }: Props) {
  const styles = variant === "plain" ? null : buttonStyles(variant);

  return (
    <RemixLink
      to={to}
      className={cn(styles, className)}
      unstable_viewTransition={!disableTransitions}
      {...props}
    />
  );
}
